<template>
  <div>
    <component
      :is="currentComponent.name"
      :current-component="currentComponent"
      :attentionType="attentionTypes.VIRTUAL"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { attentionTypes } from '@/domain/global.enum';
import ValidateDocument from '@/infrastructure/vue/components/views/ticket/ValidateDocument';
export default {
  name: 'GenerateVirtualTicket',
  components: {
    ValidateDocument,
    AssignTicket: () =>
      import('@/infrastructure/vue/components/views/ticket/AssignTicket'),
  },
  computed: {
    ...mapGetters('ticket', ['currentComponent']),
  },
  data: () => ({
    attentionTypes,
  }),
  mounted() {
    this.$store.commit('ticket/CLEAR_ALL');
  },
};
</script>

<style lang="scss" scoped></style>
